import axios from './axios';

export const getPreferences = async () => axios.get('/api/settings/preferences');
export const savePreferences = async (payload) => axios.put('/api/settings/preferences', payload);
